var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex flex-column" },
    [
      _c("div", { staticClass: "flex" }, [
        _c(
          "div",
          [
            _c("v-autocomplete", {
              attrs: {
                outlined: "",
                "prepend-icon": "mdi-magnify",
                dense: "",
                placeholder: "Filter Client...",
                items: _setup.clientList.items,
                loading: _setup.clientList.isLoading,
                clearable: ""
              },
              model: {
                value: _setup.clientList.data,
                callback: function($$v) {
                  _vm.$set(_setup.clientList, "data", $$v)
                },
                expression: "clientList.data"
              }
            })
          ],
          1
        )
      ]),
      _c("v-data-table", {
        attrs: {
          loading: _setup.tableState.isLoading,
          items: _setup.tableState.items,
          headers: _setup.headers,
          "sort-by": ["dateConducted"],
          "sort-desc": [true]
        },
        scopedSlots: _vm._u([
          {
            key: "item.action",
            fn: function({ item }) {
              return [
                _c(
                  "div",
                  { staticStyle: { display: "flex", gap: "5px" } },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          loading: _setup.tableState.isItemPrinting.has(
                            item.id
                          ),
                          icon: "",
                          color: "red",
                          dark: "",
                          outlined: ""
                        },
                        on: { click: () => _setup.onPdfHandler(item.id) }
                      },
                      [_c("v-icon", [_vm._v("mdi-file")])],
                      1
                    ),
                    !item.lock
                      ? _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              outlined: "",
                              dark: "",
                              color: "yellow darken-3"
                            },
                            on: { click: () => _setup.onEditHandler(item.id) }
                          },
                          [_c("v-icon", [_vm._v("mdi-pencil")])],
                          1
                        )
                      : _vm._e(),
                    !item.lock
                      ? _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              outlined: "",
                              dark: "",
                              color: "blue darken-3",
                              loading: _setup.tableState.isItemLocking.has(
                                item.id
                              )
                            },
                            on: {
                              click: () => _setup.onLockHandler(item.id, item)
                            }
                          },
                          [_c("v-icon", [_vm._v("mdi-lock")])],
                          1
                        )
                      : _vm._e(),
                    !item.lock && _setup.authAccessLevel >= 7
                      ? _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              outlined: "",
                              dark: "",
                              color: "red",
                              loading: _setup.deletingListRef.has(item.id)
                            },
                            on: {
                              click: () => _setup.onDeleteHandler(item.id, item)
                            }
                          },
                          [_c("v-icon", [_vm._v("mdi-delete")])],
                          1
                        )
                      : _setup.authAccessLevel >= 7
                      ? _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              outlined: "",
                              dark: "",
                              color: "blue darken-3",
                              loading: _setup.tableState.isItemLocking.has(
                                item.id
                              )
                            },
                            on: {
                              click: () => _setup.onUnlockHandler(item.id, item)
                            }
                          },
                          [_c("v-icon", [_vm._v("mdi-lock-open")])],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "item.dateConducted",
            fn: function({ item }) {
              return [
                _c("div", [
                  _c("span", [
                    _vm._v(
                      _vm._s(_setup.formatDateUS(new Date(item.dateConducted)))
                    )
                  ])
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }